import { connect } from 'react-redux';
import { IState } from '../../store';
import { IWarningsProps, WARNING_STATUS, Warnings } from './index';
import { Dispatch } from 'redux';

import { getDealType } from '../../utils/deal_type';
import { setComplaintPopupOpenValue } from '../../store/complaintPopupOpen';

type TStoreProps = Pick<IWarningsProps, 'dealType' | 'warningId'>;
type TDispatchProps = Pick<IWarningsProps, 'setComplaintPopupOpen'>;

export const mapStateToProps = (state: IState): TStoreProps => ({
  dealType: getDealType(state.offerData.offer),
  warningId: getWarningId(state),
});

export const mapDispatchToProps = (dispatch: Dispatch<IState>): TDispatchProps => ({
  setComplaintPopupOpen: (value: boolean) => dispatch(setComplaintPopupOpenValue(value)),
});

export const WarningsContainer = connect<TStoreProps, TDispatchProps>(mapStateToProps, mapDispatchToProps)(Warnings);

export function getWarningId(state: IState) {
  const {
    akkCheckPassedOfferIds,
    offerData: {
      agent,
      offer: { id },
    },
  } = state;

  if (akkCheckPassedOfferIds && akkCheckPassedOfferIds.includes(id)) {
    return WARNING_STATUS.AKK_CHECKED;
  } else if (!agent) {
    return undefined;
  } else if (agent.isRecidivist) {
    return WARNING_STATUS.RECIDIVIST;
  } else if (agent.isUserOffersHasErrors) {
    return WARNING_STATUS.ERRORS;
  } else if (agent.userTrustLevel === 'new') {
    return WARNING_STATUS.NEW;
  }

  return undefined;
}
